import { motion } from "framer-motion";

const ABOUT_IMG = "https://customer-assets-lxgj4vgw.emergentagent.net/job_atk-event-hub/artifacts/qf8d1gm9_B9ED7EF3-F123-414D-BC73-0DEEC6F41252.png";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] } }),
};

export const About = () => (
  <section id="about" className="relative py-24 md:py-32 max-w-[1400px] mx-auto px-6 md:px-10" data-testid="about-section">
    <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
      <motion.div
        variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }}
        className="md:col-span-5 relative">
        <div className="relative overflow-hidden gold-glow">
          <img src={ABOUT_IMG} alt="Jay Atk holding gold roses" className="w-full aspect-[4/5] object-cover grayscale-[15%]" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#150505] via-transparent to-transparent" />
          <div className="absolute inset-3 border border-[#D4AF37]/30 pointer-events-none" />
        </div>
      </motion.div>

      <div className="md:col-span-7 md:pl-10">
        <motion.p variants={fadeUp} custom={0} initial="hidden" whileInView="visible" viewport={{ once: true }}
          className="text-xs uppercase tracking-[0.35em] text-[#D4AF37] mb-6">The Host</motion.p>
        <motion.h2 variants={fadeUp} custom={1} initial="hidden" whileInView="visible" viewport={{ once: true }}
          className="font-serif-display text-4xl md:text-6xl leading-[0.95] tracking-tight text-[#FDFBF7] mb-8">
          Curated by <span className="italic text-gradient-gold">Jay Atk</span>
        </motion.h2>
        <motion.div variants={fadeUp} custom={2} initial="hidden" whileInView="visible" viewport={{ once: true }}
          className="space-y-5 text-[#A19D94] text-lg leading-relaxed max-w-2xl">
          <p>
            Part tastemaker, part storyteller — Jay Atk builds rooms that feel like a
            memory. He curates the sound, the setting and the crowd for an
            elevated, romantic take on the day party.
          </p>
          <p>
            Expect the records that raised you: slow jams, throwback anthems and the
            deep cuts only the real ones remember. This page is home base for every
            event to come — request, follow, and stay close.
          </p>
        </motion.div>

        <motion.div variants={fadeUp} custom={3} initial="hidden" whileInView="visible" viewport={{ once: true }}
          className="mt-10 flex gap-10">
          {[["90s–Today", "R&B Sounds"], ["5PM–10PM", "The Golden Hours"], ["1 Series", "Endless Vibes"]].map(([big, small]) => (
            <div key={small}>
              <div className="font-serif-display text-3xl text-[#D4AF37]">{big}</div>
              <div className="text-xs uppercase tracking-[0.2em] text-[#A19D94] mt-1">{small}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  </section>
);
